import React from "react";

/**
 * Orbit Ring — the 14 coloured dots around the type-26 center tile.
 *
 * Geometry taken from Shad's center_tile_new_logo artwork (9/30/26), normalised:
 *  - 14 dots, evenly spaced (360 / 14 = ~25.7deg), clockwise from 12 o'clock.
 *  - `size` is the dot DIAMETER as a fraction of the center circle's diameter,
 *    so the ring scales with the circle at every breakpoint.
 *  - Ring radius lives in SCSS (--orbit-ring-radius, 0.64 x circle diameter).
 *  - `color` is one of three tokens; the hex values live in _tile-orbit-ring.scss.
 *
 * To retune the look, edit this array — no new SVGs needed.
 */
export const ORBIT_RING_DOTS = [
    {size: 0.057, color: 'blue'},    // 12 o'clock
    {size: 0.077, color: 'orange'},
    {size: 0.103, color: 'orange'},
    {size: 0.111, color: 'orange'},
    {size: 0.121, color: 'orange'},  // 3 o'clock-ish, largest
    {size: 0.105, color: 'orange'},
    {size: 0.093, color: 'pink'},
    {size: 0.057, color: 'pink'},    // 6 o'clock
    {size: 0.036, color: 'pink'},    // smallest
    {size: 0.049, color: 'blue'},
    {size: 0.077, color: 'blue'},
    {size: 0.111, color: 'blue'},    // 9 o'clock-ish
    {size: 0.111, color: 'blue'},
    {size: 0.077, color: 'blue'},
];

const STEP = 360 / ORBIT_RING_DOTS.length;

/** Decorative ring — aria-hidden, pure CSS animation (see _tile-orbit-ring.scss). */
export const OrbitRing = () => (
    <div className="orbitRing" aria-hidden="true">
        {ORBIT_RING_DOTS.map((dot, i) => (
            <span
                key={i}
                className="orbitRing__arm"
                style={{'--angle': `${(i * STEP).toFixed(2)}deg`, '--i': i}}
            >
                <span
                    className={`orbitRing__dot orbitRing__dot--${dot.color}`}
                    style={{'--size': dot.size}}
                />
            </span>
        ))}
    </div>
);
